import { MutationPayload, Plugin, Store } from 'vuex'
import { RootStoreState } from '@/store/root/root-store.model'
import { PromiseUtils } from '@/shared/util/promise-utils'
import { authService } from '@/api/services/auth/auth.service'
import { auth } from '@/api/auth'
import { router } from '@/router'
import sessionStore from '@/session/sessionStore'

async function logout(): Promise<void> {
    try {
        await authService.logout()
    } finally {
        auth.clearSession()
        if (router.currentRoute.name !== 'login') {
            router.push({ name: 'login' })
        }
    }
}

export const userLoggedInChangedPlugin: Plugin<RootStoreState> =
    (store: Store<RootStoreState>) => {
        store.subscribe(async (mutation: MutationPayload) => {
            if (mutation.type === 'updateUserLoggedIn') {
                const userLoggedIn: boolean = mutation.payload
                if (!userLoggedIn) {
                    try {
                        await PromiseUtils.toCallUnique(
                            logout(),
                            error => PromiseUtils.handleAxiosError(error, [401]))
                    } finally {
                        sessionStore.reset()
                        store.commit('resetState')
                    }
                }
            }
        })
    }
